var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupComp"},[_c('nav-local-comp',{attrs:{"all":'Группы',"id":_vm.id,"toAll":_vm.toAll}}),_c('tabs-comp',{attrs:{"moduleName":_vm.moduleName}}),(_vm.tabs.group.active)?_c('group-crud-comp'):_vm._e(),(_vm.tabs.promocode.active)?_c('group-promocode-crud-comp'):_vm._e(),(_vm.tabs.users.active && _vm.id)?_c('users-comp',{attrs:{"onFilter":true,"required":[
      'userGroup',
      'id',
      'phone',
      'repost',
      'bonus',
      'sale',
      'bonusDate',
      'ordersCount',
      'ordersBonus',
      'ordersPrice'
    ],"groupId":Number(_vm.id)}}):_vm._e(),(_vm.tabs.users.active && !_vm.id)?_c('div',{staticClass:"div_nodata"},[_c('label',{staticClass:"label_nodata"},[_vm._v("Сначала создайте группу")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }